export default theme => ({
    header: {
        width: '100%',
        backgroundColor: theme.palette.secondary.dark,
        padding: theme.spacing.unit*1.5,
    },
});